import { Input, TimePicker, Button, Table } from "@ds/ds-snam/react";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { IMoveReservationParameters, IParametersFreezing, IShipper} from "dataModels/settings";
import moment from "moment";
import { getParametersFreezing, postShipper, putParametersFreezing } from "net/settings";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppUserRole, DsLayout, EntityType, IAppUserProfile, RequestStatus, ResponseCode, ResponseStatus, RoutePath, TIME_FORMAT } from "shared/constants";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { RootState } from "state/appStore";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import useRequestStatus from "hooks/useRequestStatus";
import NoDataFound from "components/NoDataFound";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";
import AddEntityButton from "components/AddEntityButton";
import { Input as TextInput } from "@ds/ds-snam/react";
import { useLocation, useNavigate } from "react-router";



const ShipperForm:React.FC<{}> = ():JSX.Element=>{
    const dispatch = useDispatch();
    const { t } = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const location = useLocation();
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const requestStatus = useRequestStatus();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<IShipper>({
        shipperId: "-1",
        shipperName: "",
        shipperCode: ""
    });

    useEffect(()=>{
        if(location.state && location.state.shipper){
            setFormData(location.state.shipper);
        }
    },[location.state])

    const saveFormData = () => {
        //console.log(formData)
        let popUpAction: INotificationAction;
        dispatch(requestPending());
        postShipper(formData)
            .then(response => {
                const popUpTitle:string = response.data.status===ResponseStatus.ERROR ? 'Error':(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT? 'Unprocessable content': t('settings.shipperParameters.labels.5', { ns: 'contract' }) );
                const popUpDescription:string = response.data.status===ResponseStatus.ERROR||response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?response.data.message:t('settings.shipperParameters.labels.6', { ns: 'contract' });
                const popUpStatus:NotificationsStatusType = response.data.status===ResponseStatus.ERROR?"error":(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");                       
                popUpAction = {
                    show: true,
                    title: popUpTitle,
                    description: popUpDescription,
                    status: popUpStatus,
                    onClose: (event: Event) => {
                        dispatch(hideNotification());
                    }
                };
                dispatch(showNotification(popUpAction));
                navigate(RoutePath.SETTINGS_SHIPPER_PARAMETERS);
            }).catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine())
            });
    }

    return(
        <>
            <p className="pageTitle">
                {t('settings.shipperParameters.title1', { ns: 'contract' })} 
            </p>
            <div className="listTableContainerGrey">
                <Row>
                    <Col>
                        <p className="pageSemiTitle">
                            {t('settings.shipperParameters.sub_title.0', { ns: 'contract' })}
                        </p>
                    </Col>
                </Row>
                <Row style={{ marginBottom: "12px"}}>
                             <Col xs={12} md={4}>
                                 <TextInput
                                     inputLabel={t('settings.shipperParameters.labels.0', { ns: 'contract' })} 
                                     inputValue={formData.shipperName}
                                     inputName="shipperName"
                                     inputId="shipper-name"
                                     inputDescription=""
                                     inputStatus="default"
                                     inputPlaceholder=""
                                     isDisabled={false}
                                     input-event-type="single_character"
                                     isNumberVariant={false} //STRINGTOONLYNUMBER
                                     isReadonly={false}
                                     onInputChange={(inputEvent: Event)=>{
                                         const fieldName = "shipperName";
                                         let currentData: IShipper = {...formData};
                                         if((inputEvent as CustomEvent).detail.input.value!==""){
                                             (currentData[fieldName as keyof IShipper] as string) = (inputEvent as CustomEvent).detail.input.value;
                                         }else{
                                             (currentData[fieldName as keyof IShipper] as string) = "";
                                         }
                                         setFormData(currentData);
                                     }}
                                 />
                             </Col>
                             <Col xs={12} md={4}>
                                 <TextInput
                                     inputLabel={t('settings.shipperParameters.labels.1', { ns: 'contract' })} 
                                     inputValue={formData.shipperCode?formData.shipperCode:""}
                                     inputName="shipperCode"
                                     inputId="shipper-code"
                                     inputDescription=""
                                     inputStatus="default"
                                     inputPlaceholder=""
                                     isDisabled={false}
                                     input-event-type="single_character"
                                     isNumberVariant={false} //STRINGTOONLYNUMBER
                                     isReadonly={false}
                                     onInputChange={(inputEvent: Event)=>{
                                         const fieldName = "shipperCode";
                                         let currentData: IShipper = {...formData};
                                         if((inputEvent as CustomEvent).detail.input.value!==""){
                                             (currentData[fieldName as keyof IShipper] as string) = (inputEvent as CustomEvent).detail.input.value;
                                         }else{
                                             (currentData[fieldName as keyof IShipper] as string) = "";
                                         }
                                         setFormData(currentData);
                                     }}
                                 />
                             </Col>
                         </Row>               
            </div>
            <div style={{float:'right',paddingTop:'20px',paddingBottom:'20px'}}>
                <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t('general.buttons.confirm', { ns: 'app' })}//"Conferma"
                    buttonIcon=""
                    isDisabled={formData.shipperCode==="" || formData.shipperName===""}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        saveFormData();
                    }}
                />
            </div>
        </>
    );
}
export default ShipperForm;

